import ConfigInfo from './ConfigInfo';
export default ConfigInfo;